export class Slider {
	/**
	 * Initialize a new Sections element
	 *
	 * @param {HTMLElement} node - the node that contains the root scrolling element
	 * @param {object} opts -
	 */
	constructor( node, opts ) {
		this.node = node;

		if ( ! this.node ) return;

		this.opts = {
			back: '.card-slider__go--back',
			forward: '.card-slider__go--forward',
			content: '.card-slider__content',
			items: '.card-slider__content > *',
			sticky: true,
			...opts,
		};

		this.back = this.node.querySelector( this.opts.back );
		this.forward = this.node.querySelector( this.opts.forward );
		this.content = this.node.querySelector( this.opts.content );
		this.items = this.node.querySelectorAll( this.opts.items );

		if ( ! this.back || ! this.forward || ! this.content || ! this.items.length ) return;

		window.addEventListener( 'resize', this.setState.bind( this ) );

		this.content.addEventListener( 'scroll', this.setState.bind( this ) );
		this.forward.addEventListener( 'click', this.forwardIndex.bind( this ) );
		this.back.addEventListener( 'click', this.backIndex.bind( this ) );

		this.setIndex( 0, 'auto' );
		this.setState();
	}

	setState() {
		const firstItem = this.items[ 0 ];
		const lastItem = this.items[ this.items.length - 1 ];
		const contentRect = this.content.getBoundingClientRect();
		const firstItemRect = firstItem.getBoundingClientRect();
		const lastItemRect = lastItem.getBoundingClientRect();

		this.back.disabled = firstItemRect.left >= contentRect.left;
		this.forward.disabled = lastItemRect.right <= contentRect.right + 1;
	}

	getIndex() {
		const offset = this.getLeftOffset();
		const distances = [ ...this.items ].map( ( item ) => Math.abs( item.offsetLeft - this.content.scrollLeft - offset ) );

		return distances.indexOf( Math.min( ...distances ) );
	}

	getLeftOffset() {
		const contentPos = this.content.getBoundingClientRect();
		const contentStyle = window.getComputedStyle( this.content );
		const paddingLeft = parseFloat( contentStyle.paddingLeft ) || 0;

		return contentPos.left + paddingLeft;
	}

	setIndex( index, behavior = 'smooth' ) {
		if ( index < 0 || index >= this.items.length ) return;

		const left = this.items[ index ].offsetLeft - this.getLeftOffset();

		this.content.scrollTo( {
			left: Math.max( 0, left ),
			behavior,
		} );
	}

	backIndex() {
		this.setIndex( Math.round( Math.max( this.getIndex() - 1, 0 ) ) );
	}

	forwardIndex() {
		this.setIndex( Math.round( Math.min( this.getIndex() + 1, this.items.length - 1 ) ) );
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.card-slider' ).forEach( ( node ) => {
		new Slider( node, { ...node.dataset } );
	} );
} );
